//validation utilities
//email address
export const isEmailAddressValid = (email) =>
  email?.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

export const isFirstAndLastNameValid = (firstAndLastName) =>
  firstAndLastName.match(/^[a-zA-Z\s.]*$/);

export const isCompanyNameValid = (company) => company.match(/^[0-9]*\d$/);

export const isLandlineValid = (landline) => landline.match(/^[0-9+[+-\s]*$/);
